/**
 * Keeps cart UI changes owned by the theme while Kite owns gift eligibility.
 * The only cart mutation here removes lines left behind by the retired
 * EasyGift integration. It runs at most once per browser session and only
 * after the shopper changes the cart.
 */
(function () {
  'use strict';

  if (window.__tnKiteCartBridgeLoaded) return;
  window.__tnKiteCartBridgeLoaded = true;

  var STORAGE_KEY = 'tn:legacy-easygift-cleanup:v1';
  var cleanupComplete = false;
  var cleanupScheduled = false;
  var cleanupPromise = null;

  function readCleanupStatus() {
    if (cleanupComplete) return true;

    try {
      cleanupComplete = window.sessionStorage.getItem(STORAGE_KEY) === 'complete';
    } catch (_error) {}

    return cleanupComplete;
  }

  function markCleanupComplete() {
    cleanupComplete = true;

    try {
      window.sessionStorage.setItem(STORAGE_KEY, 'complete');
    } catch (_error) {}
  }

  function legacyEasyGiftKeys() {
    var keys = new Set();

    document.querySelectorAll('[data-legacy-easygift-key]').forEach(function (row) {
      var key = row.getAttribute('data-legacy-easygift-key');
      if (key) keys.add(key);
    });

    return Array.from(keys);
  }

  function cartUpdateUrl() {
    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url) {
      return window.Theme.routes.cart_update_url;
    }

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/') + 'cart/update.js';
  }

  async function removeLegacyEasyGiftLines() {
    if (readCleanupStatus() || cleanupPromise) return cleanupPromise;

    var keys = legacyEasyGiftKeys();
    if (!keys.length) {
      markCleanupComplete();
      return;
    }

    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    cleanupPromise = fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Legacy EasyGift cleanup request failed');
        return response.json();
      })
      .then(function (cart) {
        if (cart && cart.errors) throw new Error('Legacy EasyGift cleanup was rejected');

        markCleanupComplete();
        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            detail: { reason: 'external-cart-mutation' }
          })
        );
      })
      .catch(function () {
        // Leave the session unmarked so a later cart interaction can retry.
      })
      .finally(function () {
        cleanupPromise = null;
      });

    return cleanupPromise;
  }

  function scheduleLegacyCleanup() {
    if (readCleanupStatus() || cleanupScheduled || cleanupPromise) return;

    cleanupScheduled = true;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        cleanupScheduled = false;
        removeLegacyEasyGiftLines();
      });
    });
  }

  document.addEventListener('cart:update', scheduleLegacyCleanup);
})();
